import { ABSOLUTE_URL_LANDING_PAGE, URL_LANDING_PAGE } from "../../utils/Constants";
import Body from "../../containers/Body";
import { getServerSideData } from "../../utils/CommonUtils";
export default function PageView({ data, localeSettings }) {
  return (
    <div>
      <Body data={data} />
    </div>
  );
}

export async function getServerSideProps(context) {
  const hostnameSplit = context.req.headers.host.split(":");
  const currentDomainName = hostnameSplit[0];
  if (hostnameSplit.length > 1) {
    context.req.host = currentDomainName;
  }
  const isGoibibo = currentDomainName?.indexOf("goibibo") > -1 ? true : false;
  let dataMap = {
    isIntl: false,
    lob: "flights",
    currentDomainName,
    isGoibibo,
    isFlightSchedule: true,
  };
  dataMap = (await getServerSideData(dataMap, context)) || {};
  dataMap.isGoibibo = isGoibibo;
  if (dataMap?.error) {
    console.log("Error in dataMap ==>>>", dataMap?.error);
    return {
      redirect: {
        destination: ABSOLUTE_URL_LANDING_PAGE,
        statusCode: 301,
      },
    };
  }
  if (dataMap?.redirect) {
    return {
      redirect: {
        destination:
          currentDomainName && currentDomainName !== ""
            ? `https://${currentDomainName}/${dataMap.redirect}`
            : `${URL_LANDING_PAGE}/${dataMap.redirect}`,
        statusCode: 301,
      },
    };
  }
  return {
    props: {
      data: { ...dataMap }
    },
  };
}

// PageView.propTypes = {
// 	data: PropTypes.object,
// };
